import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

import http from '@/tscapi/service/httpservice';
import { Cookie } from '@/tscapi/utils/cookie';

export const useEasyPay = (cartGuid) => {
    const queryClient = useQueryClient();
    const base = '/api/v2/';
    const cookie: Cookie = new Cookie();
    const lang = cookie.Language.substring(0, 2) || 'en';
    const updateInstallments = ({ noOfInstallments, onSuccess }) => {
        return http.put(`${base}${lang}/carts/${cartGuid}/installment`, {
            NoOfInstallments: noOfInstallments,
        });
    };
    return useMutation({
        mutationFn: updateInstallments,
        onSuccess: (response, variables) => {
            setupAnalyticsData(response.data);
            // update detail view directly
            variables.onSuccess();
            queryClient.setQueryData(
                ['bag', cookie.CartGuid, cookie.UserAccessToken?.Edp, cookie.Language],
                response?.data,
            );
        },
        onError: (error, variables, context) => {
            console.log(`${context} ${error}`);
        },
    });
};
const setupAnalyticsData = (cart) => {
    window.analyticsData.cart = cart;
};
